import BedtimeStoryGenerator from "@/components/BedtimeStoryGenerator";
import StoryGenerationErrorBoundary from "@/components/StoryGenerationErrorBoundary";
import { Welcome } from "@/components/Welcome";
import Navigation from "@/components/Navigation";
import { useState } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";

export default function Home() {
  const [showWelcome, setShowWelcome] = useState(true);

  return (
    <>
      <Navigation />
      <Welcome onComplete={() => setShowWelcome(false)} />
      
      <div className="bg-gradient-to-r from-purple-600 to-teal-600 text-white py-3 px-4 text-center">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-3">
          <div className="flex items-center gap-2">
            <Gift className="h-5 w-5" />
            <span className="font-medium">Perfect Gift Idea! Purchase gift cards for SnuggleCrafters subscriptions.</span>
          </div>
          <Link href="/buy-gift-card">
            <Button 
              variant="outline" 
              size="sm" 
              className="bg-white text-purple-600 hover:bg-purple-50 border-white"
              data-testid="link-gift-cards"
            >
              Buy Gift Cards
            </Button>
          </Link>
        </div>
      </div>

      <main id="main-content" tabIndex={-1} className="pt-16">
        <StoryGenerationErrorBoundary>
          <BedtimeStoryGenerator />
        </StoryGenerationErrorBoundary>
      </main>
    </>
  );
}
